import { useDispatch } from "react-redux";
import { hideChartKeyDialogs } from "../redux/tooltipsSlice";

const ChartKeyDialog = ({ chartType }) => {

	const dispatch = useDispatch();

	const closeDialog = () => {
		dispatch(hideChartKeyDialogs());
	}

	return (
		<div className="modal dark" onClick={closeDialog}>
			<figure className={`chart-key ${(chartType === "gauge") ? "gauge" : "nested-pie-chart"}`}>
				{
					(chartType === "gauge")
						?
						<>
							<figcaption style={{ left: "50px", top: "40px" }}>This is the range between the 25<sup>th</sup> and 75<sup>th</sup> percentile<br />responses from your peer advisors</figcaption>
							<figcaption style={{ left: "120px", top: "270px" }}>Your reponse</figcaption>
							<figcaption style={{ left: "320px", top: "270px" }}>The 90<sup>th</sup> percentile response<br />from your peer advisors</figcaption>
						</>
						:
						<>
							<figcaption style={{ left: "435px", top: "50px" }}>Responses <br />from your<br />peer advisors</figcaption>
							<figcaption style={{ left: "45px", top: "272px" }}>Responses<br/>from your<br/>target advisors</figcaption>
						</>
				}
				<button className="close"></button>
			</figure>
		</div>
	)
}

export default ChartKeyDialog
